import { CHORD_VARIANTS, buildChord } from '../data/chords';
import { parseChordId } from '../hooks/chordIdParser';

/**
 * The ordered, deduped set of variant-chip ids for a chord card.
 *
 * Anchored to the BASE chord id (the diatonic chord the card represents), so the
 * menu stays stable no matter which variant is currently displayed. Always leads
 * with the base chord itself.
 *
 * This must NOT be recomputed from the active variant — doing so collapses the
 * menu: e.g. selecting Esus2 on an Em card would rebuild from sus2's variants
 * (`maj, sus4, add9`), dropping every minor-family sibling and surfacing a bare
 * "E" major chip — a one-way trip out of the minor chord.
 */
export function getVariantChipIds(baseChordId: string): string[] {
  const { root, quality } = parseChordId(baseChordId);
  const variants = CHORD_VARIANTS[quality] ?? [];
  const ids = [baseChordId, ...variants.map((q) => buildChord(root, q).id)];
  return Array.from(new Set(ids));
}
